// Module
var code = "<div class=\"am-chart screenshotable\"></div>\n";
// Exports
module.exports = code;